import { DomUtils } from "../utils/domUtils";
import { BaseController } from "./base";

export const NotAuthorizedConstants = {
	backToLoginButton: "backToLoginButton"
};

export class NotAuthorizedController extends BaseController {
	constructor() {
		super();

		this._returnUrl = null;
	}

	Init() {
		this._GetContextData();
		this._BindEvents();

		this._SetupTimer();
	}

	_GetContextData() {
		this._returnUrl = window.returnUrl || "./";
	}

	_BindEvents() {
		const backToLoginButton = DomUtils.GetElement(NotAuthorizedConstants.backToLoginButton);
		backToLoginButton.addEventListener("click", this._OnLoginButtonClick.bind(this));
	}

	_OnLoginButtonClick() {
		window.location.href = this._returnUrl;
	}

	_SetupTimer() {
		setTimeout(() => {
			this._OnLoginButtonClick();
		}, 10000);
	}
}
